import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

// *******************************************************
// RAIL
// *******************************************************
const railOuterStyle = {
    position: 'absolute',
    width: '100%',
    height: 42,
    transform: 'translate(0%, -50%)',
    borderRadius: 7,
    cursor: 'pointer',
    padding: '5px'
}

const railInnerStyle = {
    position: 'absolute',
    width: '100%',
    height: 8,
    transform: 'translate(0%, -50%)',
    borderRadius: 7,
    pointerEvents: 'none',
    backgroundColor: 'rgb(155,155,155)',
}

const sliderValueStyle = {
    display: 'flex',
    marginTop: '14px',
    marginLeft: '3px',
    fontSize: '15px'
}
export function SliderRail({ getRailProps, enabled = true, additionalRailInnerStyle ={}}) {
    return (
        <Fragment>
            <div style={{...railOuterStyle,cursor: `${enabled ? 'pointer' : 'not-allowed'}` }}
                {...getRailProps()} />
            <div style={{...railInnerStyle,...additionalRailInnerStyle}} />
        </Fragment>
    )
}

SliderRail.propTypes = {
    getRailProps: PropTypes.func.isRequired,
}

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
export function Handle({
    domain: [min, max],
    handle: { id, value, percent },
    disabled,
    getHandleProps,showRangeValue = false, valueType, enabled = true,
    sliderHeight,sliderWidth
}) {
    return (
        <Fragment>
            <div
                style={{
                    left: `${percent}%`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 5,
                    width: 28,
                    height: 42,
                    cursor: `${enabled ? 'pointer' : 'not-allowed'}`,
                    // border: '1px solid white',
                    backgroundColor: 'none',
                }}
                {...getHandleProps(id)}>
                    {showRangeValue && <div style={{ fontFamily: "Roboto",
                        fontSize: 12,
                        marginTop: '-10px',
                        marginLeft: '9px',
                        display: 'flex'}}>
                    <span>{value}</span> 
                    {valueType ?
                        <span style={sliderValueStyle}>
                            <sup>{valueType}</sup>
                        </span>: ""}
                    </div>}
                </div>
            <div
                role="slider"
                aria-valuemin={min}
                aria-valuemax={max}
                aria-valuenow={value}
                style={{
                    left: `${percent}%`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 2,
                    width: `${sliderWidth ? sliderWidth : '12px'}`,
                    height: `${sliderHeight ? sliderHeight : '12px'}`,
                    borderRadius: '50%',
                    boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
                    backgroundColor: disabled ? '#666' : '#487bce',
                }}
            />
        </Fragment>
    )
}

Handle.propTypes = {
    domain: PropTypes.array.isRequired,
    handle: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    getHandleProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

Handle.defaultProps = {
    disabled: false,
}

// *******************************************************
// KEYBOARD HANDLE COMPONENT
// Uses a button to allow keyboard events
// *******************************************************
export function KeyboardHandle({
    domain: [min, max],
    handle: { id, value, percent },
    disabled,
    getHandleProps,
}) {
    return (
        <button
            role="slider"
            aria-valuemin={min}
            aria-valuemax={max}
            aria-valuenow={value}
            style={{
                left: `${percent}%`,
                position: 'absolute',
                transform: 'translate(-50%, -50%)',
                zIndex: 2,
                width: 12,
                height: 12,
                borderRadius: '50%',
                boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
                backgroundColor: disabled ? '#666' : '#ffc400',
            }}
            {...getHandleProps(id)}
        />
    )
}

KeyboardHandle.propTypes = {
    domain: PropTypes.array.isRequired,
    handle: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    getHandleProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

KeyboardHandle.defaultProps = {
    disabled: false,
}

// *******************************************************
// TRACK COMPONENT
// *******************************************************
export function Track({ source, target, getTrackProps, disabled, trackHeight }) {
    return (
        <div
            style={{
                position: 'absolute',
                transform: 'translate(0%, -50%)',
                height: `${trackHeight ? trackHeight : '8px'}`,
                zIndex: 1,
                backgroundColor: disabled ? '#999' : '#487bce',
                borderRadius: 7,
                cursor: 'pointer',
                left: `${source.percent}%`,
                width: `${target.percent - source.percent}%`,
            }}
            {...getTrackProps()}
        />
    )
}

Track.propTypes = {
    source: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    target: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    getTrackProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

Track.defaultProps = {
    disabled: false,
}

// *******************************************************
// TICK COMPONENT
// *******************************************************
export function Tick({ tick, value, count, format, index }) {
    return (
        <div className={`ticks-value ${tick.id}`}  style={{
            left: `${tick.percent}%`,
        }}>
            <div
                style={{
                    position: 'absolute',
                    marginTop: 12,
                    width: 2,
                    height: 8,
                    backgroundColor: 'rgb(200,200,200)',
                    left: `${tick.percent}%`,
                }}
            />
            <div className={`${(100 / count) > 16 ? "tick-dateTime": '' } ${tick.percent > '88' && tick.percent < '98' ? 'w-85': ''}`}
                style={{
                    position: 'absolute',
                    marginTop: 22,
                    fontSize: 12,
                    textAlign: 'center',
                    marginLeft: `${-((100 / count) - 2) / 2}%`,
                    width: `${100 / count}%`,
                        left: `${count > 5 && index === 4 && count < 8 ? `${tick.percent - 2}%` : `${tick.percent}%`}`,
                }}
            >
                {format(tick.value)}
            </div>
        </div>
    )
}

Tick.propTypes = {
    tick: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
    }).isRequired,
    count: PropTypes.number.isRequired,
    format: PropTypes.func.isRequired,
}

Tick.defaultProps = {
    format: d => d,
}
